export default __webpack_public_path__ + "static/media/epilogue.562398ba.md";